export default __webpack_public_path__ + "static/media/efd01e92c57e4248b5923f40dc879c92.svg";